"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChannelsExposer = void 0;
class ChannelsExposer {
    // eslint-disable-next-line
    constructor(channelProviderOrClient) {
        this.channelProviderOrClient = channelProviderOrClient;
        this.exposeFunction = async (target, config) => {
            const { key, options, meta } = config;
            const { id } = meta;
            const action = `${id}.${(options === null || options === void 0 ? void 0 : options.action) || key}`;
            await this.channelProviderOrClient.register(action, async ({ args }) => {
                return target(...args);
            });
            return { action };
        };
        this.exposeMeta = async ({ id }, props) => {
            const action = `api-meta:${id}`;
            await this.channelProviderOrClient.register(action, () => ({ props }));
        };
    }
}
exports.ChannelsExposer = ChannelsExposer;
